// Sports ZenAnalytics supports. Onboarding still asks for one to keep
// signup light (PRODUCT-GUIDELINES.md §2), but a profile can track several
// via profiles.game_plan_sports (comma-separated) — see §5 and the header
// SportSwitcher in App.js.
export const RACKET_SPORTS = [
  { value: 'tennis',       label: 'Tennis',       icon: '🎾' },
  { value: 'padel',        label: 'Padel',        icon: '🏸' },
  { value: 'squash',       label: 'Squash',       icon: '🟡' },
  { value: 'badminton',    label: 'Badminton',    icon: '🏸' },
  { value: 'pickleball',   label: 'Pickleball',   icon: '🎾' },
  { value: 'table_tennis', label: 'Table Tennis', icon: '🏓' },
];

// The browser's own timezone is the default; the user confirms or changes it.
export function browserTimezone() {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; } catch (e) { return 'UTC'; }
}

export function listTimezones() {
  let zones = [];
  try { zones = Intl.supportedValuesOf('timeZone'); } catch (e) { zones = []; }
  const own = browserTimezone();
  if (!zones.includes(own)) zones = [own, ...zones];
  if (!zones.includes('UTC')) zones = [...zones, 'UTC'];
  return zones;
}

// The browser's own locale is the default for date/number formatting —
// same pattern as browserTimezone() above. This is formatting only (date
// order, decimal separator, etc.) — the UI's own text is always English
// regardless of locale (see countryData.js).
export function browserLocale() {
  try { return navigator.language || 'en-GB'; } catch (e) { return 'en-GB'; }
}

// A representative set of locales for the picker — not exhaustive, but a
// country selection (see countryData.js) will set the right one directly
// even when it isn't in this short list, so this is just for manual choice.
export function listLocales() {
  return [
    'en-GB', 'en-US', 'en-AU', 'en-CA', 'en-NZ', 'en-IE', 'en-ZA', 'en-IN',
    'fi-FI', 'sv-SE', 'nb-NO', 'da-DK', 'de-DE', 'de-AT', 'de-CH',
    'fr-FR', 'fr-CA', 'es-ES', 'es-MX', 'pt-PT', 'pt-BR', 'it-IT', 'nl-NL',
    'pl-PL', 'cs-CZ', 'ja-JP', 'zh-CN', 'ko-KR',
  ];
}

// A raw BCP-47 tag like "de-DE" means nothing to most people — this turns
// it into something recognizable: the country it belongs to plus a live
// example of what a date actually looks like in it, e.g.
// "Germany — 20/10/2026". Works for any locale (not just the curated list
// above) since a Country selection can set one we didn't hand-name.
const _EXAMPLE_DATE = new Date(2026, 9, 20); // 20 Oct 2026 — day/month are unambiguous from each other
export function localeLabel(code) {
  if (!code) return code;
  let region = '';
  try {
    const parts = new Intl.Locale(code);
    region = parts.region || '';
  } catch (e) {
    region = code.split('-')[1] || '';
  }
  let regionName = '';
  try {
    regionName = new Intl.DisplayNames(['en'], { type: 'region' }).of(region) || '';
  } catch (e) {
    regionName = '';
  }
  let example = code;
  try {
    example = _EXAMPLE_DATE.toLocaleDateString(code, { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch (e) {
    // keep raw code as the example if the browser doesn't recognize it
  }
  return regionName ? `${regionName} — ${example}` : example;
}
